import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../../components/navbar/navbarComponent";
import { getAllUsers } from "../../redux/actions";
import ResetearUsuarioComponent from "./configurarUsuario/resetearUsuario";
import { NewUserIcon } from "../../components/icons/SvgIcons";
import ConfigurarUsuarioComponent from "./configurarUsuario";
import CambiarTipoUsuarioComponent from "./configurarUsuario/cambiarTipoUsuario";
import EliminarUsuarioComponent from "./configurarUsuario/eliminarUsuario";

function UsuariosComponent() {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refreshUsuarios = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);

      const response = await dispatch(getAllUsers());

      if (Array.isArray(response)) {
        setUsers(response);
      }
    } catch (error) {
      console.error("Error al cargar los usuarios:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    refreshUsuarios();
  }, [refreshUsuarios]);


  const [isConfiguracionOpen, setIsConfiguracionOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const openConfiguracion = (id) => {
    setSelectedUserId(id);
    setIsConfiguracionOpen(true);
  };

  const closeConfiguracion = () => {
    setIsConfiguracionOpen(false);
  };

  const [isModalContrasenaOpen, setIsModalContrasenaOpen] = useState(false);

  const openContrasenaModal = () => {
    setIsModalContrasenaOpen(true);
    closeConfiguracion()
  };

  const closeContrasenaModal = () => {
    setIsModalContrasenaOpen(false)
    setSelectedUserId(null);
  };

  const [isModalTipoOpen, setIsModalTipoOpen] = useState(false);

  const openTipoModal = () => {
    setIsModalTipoOpen(true);
    closeConfiguracion()
  };

  const closeTipoModal = () => {
    setIsModalTipoOpen(false)
    setSelectedUserId(null);
  };

  const [isModalEliminarOpen, setIsModalEliminarOpen] = useState(false);

  const openEliminarModal = () => {
    setIsModalEliminarOpen(true);
    closeConfiguracion()
  };

  const closeEliminarModal = () => {
    setIsModalEliminarOpen(false)
    setSelectedUserId(null);
  };

  return (
    <div>
      <Navbar />

      {/* Render condicional del modal Configuración */}
      {isConfiguracionOpen && <ConfigurarUsuarioComponent userId={selectedUserId} closeConfiguracion={closeConfiguracion} openContrasenaModal={openContrasenaModal} openTipoModal={openTipoModal} openEliminarModal={openEliminarModal} />}
      {/* Render condicional del modal Contraseña */}
      {isModalContrasenaOpen && <ResetearUsuarioComponent userId={selectedUserId} onClose={closeContrasenaModal} onActualizacion={refreshUsuarios} />}
      {/* Render condicional del modal Tipo */}
      {isModalTipoOpen && <CambiarTipoUsuarioComponent userId={selectedUserId} onClose={closeTipoModal} onActualizacion={refreshUsuarios} />}
      {/* Render condicional del modal Eliminar */}
      {isModalEliminarOpen && <EliminarUsuarioComponent userId={selectedUserId} onClose={closeEliminarModal} onActualizacion={refreshUsuarios} />}

      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF] ">
        <div className="text-[#3d4245] text-[28px] font-bold font-inter sm:my-[3rem] my-[1rem]">
          Usuarios
        </div>

        <div className="sm:w-[40rem]  flex-col justify-start items-start gap-3 inline-flex sm:mx-[1rem] mb-[4rem]">
          <Link
            to="/nuevo_usuario"
            className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
          >
            <div className="w-[49px] h-[49px] relative">
              <NewUserIcon className="size-18 stroke-[#0477ad]" />
            </div>
            <div className="flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-[#0477ad] text-lg font-bold font-inter">
                Nuevo usuario
              </div>
              <div className="text-[#687073] text-sm font-normal font-inter">
                Registrar un nuevo usuario
              </div>
            </div>
          </Link>


          <div className="self-stretch rounded-lg border border-[#c5dfff] flex-col flex overflow-hidden">
            {/* Encabezados */}
            <div className="self-stretch bg-[#c5dfff] flex items-center h-[3.5rem] px-4">
              <div className="text-[#0a5477] text-xs font-bold font-inter uppercase flex-1 text-left">
                Nombre y apellido
              </div>
              <div className="text-[#0a5477] text-xs font-bold font-inter uppercase flex-1 text-center">
                Tipo
              </div>
              <div className="text-[#0a5477] text-xs font-bold font-inter uppercase flex-1 text-right pr-4">
                Acción
              </div>
            </div>

            {/* Cuerpo de la tabla */}
            {loading ? (
              <div className="text-center py-4">
                Cargando usuarios...
              </div>
            ) : error ? (
              <div className="flex flex-col items-center justify-center py-12 text-center bg-white">
                <h2 className="text-lg font-semibold text-gray-700">
                  No se pudieron cargar los usuarios
                </h2>

                <p className="mt-2 text-sm text-gray-500">
                  Ocurrió un problema al comunicarse con el servidor.
                </p>
              </div>
            ) : (
              users.map(({ nombreCompleto, tipo, id }, index) => (
                <div
                  key={index}
                  className="h-20 bg-white border-b border-[#c5dfff] flex items-center px-4"
                >
                  <div className="text-[#3d4245] text-base font-semibold font-inter flex-1 text-left">
                    {nombreCompleto}
                  </div>

                  <div className="text-[#3d4245] text-base font-semibold font-inter flex-1 text-center">
                    {tipo}
                  </div>

                  <div className="flex-1 text-right">
                    <button
                      type="button"
                      onClick={() => openConfiguracion(id)}
                      className="px-4 py-2 bg-white rounded-lg border border-[#0477ad] text-[#0477ad] text-sm font-medium font-inter"
                    >
                      Configurar
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsuariosComponent;


